import Image from 'next/legacy/image'
import { useTranslation } from 'next-i18next'
import styled from 'styled-components'

import { breakpoints } from '@/styles'

import { SectionHeading } from '../elements'
import LandlordFaq from './landlords-faq'
import faqImage from '../images/faq.png'

const Section = styled.section`
  margin-bottom: 0 !important;
`

const Grid = styled.div`
  display: grid;
  grid-template-columns: 264px 1fr;
  grid-gap: 0 max(72px, 6vw);
  @media (max-width: ${breakpoints.tabletLandscape}) {
    grid-template-columns: 1fr;
  }
`

const Sidebar = styled.div``

const Heading = styled(SectionHeading)`
  text-align: left;
  @media (max-width: ${breakpoints.tabletLandscape}) {
    text-align: center;
  }
`

const ImageContainer = styled.div`
  position: relative;
  height: 384px;
  width: 100%;
  @media (max-width: ${breakpoints.tabletLandscape}) {
    display: none;
  }
`

const FaqSection: React.FC<{}> = () => {
  const { t } = useTranslation('pricing')
  return (
    <Section>
      <Grid>
        <Sidebar>
          <Heading>{t('pricing:Frequently asked questions')}</Heading>
          <ImageContainer>
            <Image
              src={faqImage}
              layout="fill"
              sizes="264px"
              objectFit="contain"
              objectPosition="top"
              alt=""
              placeholder="blur"
            />
          </ImageContainer>
        </Sidebar>
        <LandlordFaq trackingId="landlord-pricing-faq" />
      </Grid>
    </Section>
  )
}

export default FaqSection
